import { configureStore } from '@reduxjs/toolkit'
import counterReducer from '../features/counter/counterSlice'
import userReducer from '../features/user/userSlice'
import usersReducer from '../features/Users/UsersSlice'
import appReducer from '../features/app/appSlice'
import orderReducer from '../features/orders/orderSlice'
import orderDetailSlice from 'src/features/orderDetail/orderDetailSlice'
import selectsSlice from 'src/features/select/selectSlice'
import PageLoader from 'src/features/pageLoader/PageLoader'
import configSlice from 'src/features/configs/configSlice'
export default configureStore({
  reducer: {
    counter: counterReducer,
    user: userReducer,
    users: usersReducer,
    sidebarShow: appReducer,
    orders: orderReducer,
    orderDetail: orderDetailSlice,
    selects: selectsSlice,
    PageLoader: PageLoader,
    configs: configSlice,
  },
})
